// src/app/services/loader.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loadingCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

  /**
   * Démarre une requête (incrémente le compteur)
   */
  startLoading() {
    this.loadingCount++;
    if (this.loadingCount > 0) {
      this.loadingSubject.next(true);
    }
  }

  /**
   * Termine une requête (décrémente le compteur)
   */
  stopLoading() {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }
    if (this.loadingCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  /**
   * Méthode de compatibilité pour l'ancienne API
   * @deprecated Utilisez startLoading() et stopLoading() à la place
   */
  setLoading(isLoading: boolean) {
    if (isLoading) {
      this.startLoading();
    } else {
      this.stopLoading();
    }
  }
}
